import * as React from "react";
const CaseSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M28.83 3.17a3.999 3.999 0 0 0-5.71.056l-6.677 7.801-1.318-1.322a3 3 0 0 0-4.244 0l-9.586 9.587a1 1 0 0 0 0 1.414l10 10a1 1 0 0 0 1.413 0l9.587-9.581a2.998 2.998 0 0 0 0-4.244l-1.323-1.321 7.801-6.685c.02-.018.04-.035.057-.054a4 4 0 0 0 0-5.651ZM12 28.586 9.915 26.5l2.792-2.794a1 1 0 0 0-1.414-1.414L8.5 25.085 6.915 23.5l2.792-2.794a1 1 0 0 0-1.414-1.414L5.5 22.085 3.413 20 9 14.414 17.586 23 12 28.586ZM27.44 7.387l-8.59 7.352a1 1 0 0 0-.057 1.467l2.082 2.086a1 1 0 0 1 0 1.414L19 21.581 10.415 13l1.875-1.875a1 1 0 0 1 1.413 0l2.087 2.086a1 1 0 0 0 1.467-.057l7.355-8.594a2 2 0 0 1 2.828 2.827Z"
    />
  </svg>
);
export default CaseSVG;
